import React from 'react';
import { useTranslation } from '../hooks/useTranslation.js';
import Footer from '../components/Footer.jsx';
import { withLinks } from '../utils/textLinks.jsx';
import { companyContact } from '../config/company.js';

// A short lead, the conversational data analysis set apart, then one row per
// core function with its key facts. All of it comes from the language files.
const FinancePage = () => {
  const { currentLang, getPageTranslations } = useTranslation('finance');
  const t = getPageTranslations('finance');

  return (
    <div className="min-h-screen bg-bg-main text-text-primary">
      <main className="site-main">
        <section className="site-hero site-hero--single">
          <div className="finance-hero">
            <h1 className="site-title">{t.hero?.title}</h1>
            <p className="finance-lead">{withLinks(t.hero?.lead || '', currentLang)}</p>
          </div>
        </section>

        {t.analysis && (
          <section className="finance-analysis">
            <h2 className="site-heading">{t.analysis.title}</h2>
            <div className="finance-analysis__text">
              {t.analysis.paragraphs?.map((paragraph, index) => (
                <p key={index}>{withLinks(paragraph, currentLang)}</p>
              ))}
            </div>
          </section>
        )}

        {t.features && (
          <section className="signal-section">
            <header className="signal-section-header">
              <h2>{t.features.title}</h2>
            </header>
            <div className="finance-features">
              {t.features.items?.map((item) => (
                <article className="finance-feature" key={item.title}>
                  <h3>{item.title}</h3>
                  <div>
                    <p>{item.text}</p>
                    {item.facts && <p className="finance-feature__facts">{item.facts}</p>}
                  </div>
                </article>
              ))}
            </div>
          </section>
        )}

        <section className="site-contact">
          <div>
            <h2 className="site-heading">{t.cta?.title}</h2>
            <p className="finance-cta__lead">{t.cta?.subtitle}</p>
          </div>
          <a
            className="homepage-button-primary"
            href={`mailto:${companyContact.email}?subject=${encodeURIComponent(t.cta?.subject || '')}`}
          >
            {t.cta?.button}
          </a>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default FinancePage;
